/*****************************************************************************************************************************************************
 * Revision History
 * 2025-01-02 TBH - Use credits from bindConfirmationList()/unx_sp_web_ConfirmationChargeCredit instead of itemList from bindCartList()/FeeSummary session variable.
 * 2025-01-09 TBH - Set referenceNumber from response.referenceId ("X" + people ID) in bindConfirmationList().
 *****************************************************************************************************************************************************/
export default function cartConfirmation() {
// console.log( 'cartConfirmation' );
  return {
    cardDetails: [],                // unused
    cartConfirmationDetails: [],    // fetch( "/api/Checkout/Confirmation" ) response
    adddressPhoneDetails: [],       // unused
    credits: [],                    // Fee Summary (Charge/Credits)
    payments: [],                   // Payments
    terms: [],                      // unused (Year/Terms)
    showErrorMesage: "",
    message: "Loading information please wait...",
    showLoader: false,
    total_Amount: 0,                // Fee Summary total
    isSubmitting: false,
    currentFormattedDate: '',
    confirmationMessage: '',        // use payments.receiptText intead
    paymentReceiptNumber: '',       // use payments.receiptNumber instead
    referenceNumber: '',            // DCE ID# ("X" + people ID)
    entryDate: '',                  // use currentFormattedDate instead
    addressDetails: '',
    localAddress: '',               // unused
    permanentAddress: '',           // unused
    phoneDetails: '',
    addedCoursesList: [],           // unused
    waitListCoursesList: [],
    scheduledCoursesList:[],
    people: '',
    isSucess:false,       
    debug:false,
     
    formatDate(dateValue) {
      const options = { month: "short", day: "numeric" };
      const formattedDate = new Date(dateValue).toLocaleDateString();
      return formattedDate;
    },
    bindProfile() {
      this.addressDetails = JSON.parse( sessionStorage.getItem( 'addressDetails' ));
      this.phoneDetails = JSON.parse( sessionStorage.getItem( 'phoneDetails' ));
    },

    bindConfirmationList() {
// console.log( 'bindConfirmationList()' );
      this.showLoader = true;

// console.log( 'debug: ' + this.debug );        // Unused. Seeing if can set a debug flag from HTML.

      this.waitlistCartList = [];
      this.enrollmentCartList = [];
      fetch( "/api/Checkout/Confirmation", {
      // From unx_sp_web_ConfirmationChargeCredit
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        }
      }).then(( response ) => {
        return( response.json());
      }).then(( response ) => {
        if( response == undefined ) {
          this.message = "An unknown error has occurred. Please try again later.";
// console.log( this.message ); 
        } else if( !response.isSuccess ) {
        // If considered logged out then iSuccess is false and status is 401 (unauthorized).
          this.message = response.messages.length > 0 ? response.messages.join( ', ') : response.message;
// console.log( this.message ); 
        } else {
// console.log( 'response: ' + JSON.stringify( response ));

          this.cartConfirmationDetails = response;
                        
          this.referenceNumber = response.referenceId;

          this.scheduledCoursesList = response.scheduledCourses;
          this.waitlistCartList = response.waitlistCourses;

          Array.prototype.push.apply( this.credits, response.credits );
          this.total_Amount = response.credits.reduce(( sum, item ) => sum += item.fee, 0 );
// console.log( 'total_Amount: ' + JSON.stringify( this.total_Amount ));

          Array.prototype.push.apply( this.terms, response.terms );
          Array.prototype.push.apply( this.payments, response.payments );

// console.log( 'Starting Confirmation End' );
          setTimeout( function () {
            fetch( "/api/Checkout/clearUserSession", {
              method: "get",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              }
            }).then(( response ) => {
              return( response.json());
            }).then(( response ) => {
              if( response == undefined ) {
// console.log( 'Confirmation End failed. Null response.' ); 
              } else if( !response.isSuccess ) {
// console.log( 'Confirmation End failed. Response: ' + JSON.stringify( response ));
              } else {
// console.log( 'Confirmation End succeeded. Response: ' + JSON.stringify( response ));
              }
            })
          }, 1500 );
// console.log( 'Completed End Confirmation' );
        };

        this.showLoader = false;
        this.isSucess = response.isSuccess; 

// console.log( 'response.isSuccess: ' + response.isSuccess );
// console.log( 'this.isSucess [sic]: ' + this.isSucess + ' (must be true for anything to appear on confirmation page.');
      });
    },
    init() {
      this.currentFormattedDate = new Date().toLocaleDateString();
      this.bindProfile();
      this.bindConfirmationList();
    },
  };
}
